import { render, staticRenderFns } from "./BarrelClearedModal.vue?vue&type=template&id=2d6ba1dd&"
import script from "./BarrelClearedModal.vue?vue&type=script&lang=ts&"
export * from "./BarrelClearedModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports